<div class="exito-shell">
    <div class="exito-hero">
        <div class="ring-outer" [class.ring-outer--visible]="visible">
            <div class="ring-inner" [class.ring-inner--visible]="visible">
                <ion-icon name="checkmark-circle" class="check-icon" [class.check-icon--visible]="visible"></ion-icon>
            </div>
        </div>
        <h2>{{ title }}</h2>
        @if (message) {
        <p>{{ message }}</p>
        }
    </div>

    @if (badgeLabel && badgeValue) {
    <div class="orden-numero">
        <p class="eyebrow">{{ badgeLabel }}</p>
        <div class="orden-badge">
            <ion-icon [name]="badgeIcon"></ion-icon>
            <span>{{ badgeValue }}</span>
        </div>
        @if (hint) {
        <p class="hint">{{ hint }}</p>
        }
    </div>
    }

    <div class="exito-acciones">
        @if (primaryText) {
        <button type="button" class="boton-primario" (click)="primary()">
            <ion-icon name="add-outline"></ion-icon>
            {{ primaryText }}
        </button>
        }
        <button type="button" class="boton-plano" (click)="secondary()">{{ secondaryText }}</button>
    </div>
</div>
